import React, { ReactElement } from 'react';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import {
  LocalizationProvider,
  renderTimeViewClock, TimeField,
  TimePicker,
} from '@mui/x-date-pickers';

export const TimeEditCell = ({
  props,
  schema,
}: {
  props: any;
  schema: any;
}): ReactElement => {
  const def = props.value ? dayjs(props.value, 'HH:mm') : null;

  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <TimeField
          ampm={false}
          defaultValue={def}
          onChange={(newValue: any) => {
            props.api.setEditCellValue({
              id: props.id,
              field: props.field,
              value:
                newValue === null
                  ? null
                  : dayjs(newValue, 'HH:mm').format('HH:mm'),
            });
          }}
        />
      </LocalizationProvider>
    </>
  );
};
